module.exports = __webpack_public_path__ + "img/dtx_darktokenscx.39edae1.png";